/* eslint-disable */
export default {
  pages: {
    key: 'title',
    data: [
      // DASHBOARDS
      { title: 'Dashboard', url: '/dashboard', icon: 'MonitorIcon', is_bookmarked: true },
      { title: 'Marketplace', url: '/apps/eCommerce/shop', icon: 'ShoppingBagIcon', is_bookmarked: false },
      { title: 'Database', url: '/database/automations', icon: 'DatabaseIcon', is_bookmarked: true },
      { title: 'Cloudify Convert', url: '/Extensions/invoice', icon: 'CloudLightningIcon', is_bookmarked: false },
      { title: 'Data Migration', url: '/Extensions/dataMigration', icon: 'CloudDrizzleIcon', is_bookmarked: true },
      { title: 'Pricing', url: '/pricing', icon: 'CreditCardIcon', is_bookmarked: false },
    ],
  },
}
/* eslint-enable */
